import { render, staticRenderFns } from "./UpdateTenantWindow.vue?vue&type=template&id=10d4b959&scoped=true"
import script from "./UpdateTenantWindow.vue?vue&type=script&lang=js"
export * from "./UpdateTenantWindow.vue?vue&type=script&lang=js"
import style0 from "./UpdateTenantWindow.vue?vue&type=style&index=0&id=10d4b959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d4b959",
  null
  
)

export default component.exports